import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetCustomerById } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";

const ViewCustomer = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();
  let param = useParams();
  const customer_id = param.Customer_id;
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    website: "",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    term: "Select Term",
    balance: "0",
    notes: "",
    b_street: "",
    b_city: "",
    b_state: "",
    b_zip: "",
    b_country: "",
    b_phone1: "",
    b_phone2: "",
    s_street: "",
    s_city: "",
    s_state: "",
    s_zip: "",
    s_country: "",
    s_name: "",
    s_phone: "",
  });

  // const ActsGrid = [
  //   {
  //     field: "note",
  //     headerText: "Ledger Note",
  //     minWidth: "360",
  //     width: "440",
  //     maxWidth: "650",
  //     textAlign: "left",
  //   },
  //   {
  //     field: "datetime",
  //     headerText: "DateTime",
  //     minWidth: "180",
  //     width: "180",
  //     maxWidth: "240",
  //     textAlign: "center",
  //   },
  //   {
  //     field: "credit",
  //     headerText: "Credit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "debit",
  //     headerText: "Debit",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  //   {
  //     field: "bal",
  //     headerText: "Balance",
  //     width: "100",
  //     format: "C2",
  //     textAlign: "right",
  //   },
  // ];

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Customer");
  };

  useEffect(() => {
    async function fetchData() {
      if (customer_id) {
        TimeoutUtility.resetTimeout();
        await GetCustomerById(customer_id)
          .then((result) => {
            setFormData({
              name: result.data.name || "",
              phone: result.data.phone || "",
              email: result.data.email || "",
              website: result.data.website || "",
              contact_name: result.data.contact_name || "",
              contact_phone: result.data.contact_phone || "",
              contact_email: result.data.contact_email || "",
              term: result.data.term
                ? { label: result.data.term, value: result.data.term_id }
                : "Select Term",
              balance: result.data.balance || "0",
              notes: result.data.notes || "",
              b_street: result.data.b_street || "",
              b_city: result.data.b_city || "",
              b_state: result.data.b_state || "",
              b_zip: result.data.b_zip || "",
              b_country: result.data.b_country || "",
              b_phone1: result.data.b_phone1 || "",
              b_phone2: result.data.b_phone2 || "",
              s_street: result.data.s_street || "",
              s_city: result.data.s_city || "",
              s_state: result.data.s_state || "",
              s_zip: result.data.s_zip || "",
              s_country: result.data.s_country || "",
              s_name: result.data.s_attention_name || "",
              s_phone: result.data.s_phone || "",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [customer_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="VIEW CUSTOMER" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>GENERAL INFORMATION</b>
                </div>
                <TextInputField
                  label="Name:"
                  name="name"
                  value={formData.name}
                  placeholder="Name"
                  disabled
                />
                <TextInputField
                  label="Phone:"
                  name="phone"
                  value={formData.phone}
                  placeholder="Phone"
                  disabled
                />
                <TextInputField
                  label="Email:"
                  name="email"
                  value={formData.email}
                  placeholder="Email"
                  disabled
                />
                <TextInputField
                  label="Website:"
                  name="website"
                  value={formData.website}
                  placeholder="Website"
                  disabled
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  placeholder="Opening Balance"
                  disabled
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>CONTACT INFORMATION</b>
                </div>
                <TextInputField
                  label="Contact Name:"
                  name="contact_name"
                  value={formData.contact_name}
                  placeholder="Contact Name"
                  disabled
                />
                <TextInputField
                  label="Contact Phone:"
                  name="contact_phone"
                  value={formData.contact_phone}
                  disabled
                  placeholder="Contact Phone"
                />
                <TextInputField
                  label="Contact Email:"
                  name="contact_email"
                  value={formData.contact_email}
                  disabled
                  placeholder="Contact Email"
                />
                <SelectField
                  label="Terms:"
                  name="term"
                  value={formData.term}
                  isDisabled
                  placeholder="Terms"
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  disabled
                  placeholder="Notes"
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>BILLING ADDRESS</b>
                </div>
                <TextAreaField
                  label="Street:"
                  name="b_street"
                  value={formData.b_street}
                  disabled
                  placeholder="Street"
                />
                <TextInputField
                  label="City:"
                  name="b_city"
                  value={formData.b_city}
                  disabled
                  placeholder="City"
                />
                <TextInputField
                  label="Zip:"
                  name="b_zip"
                  value={formData.b_zip}
                  disabled
                  placeholder="Zip"
                />
                <TextInputField
                  label="State:"
                  name="b_state"
                  value={formData.b_state}
                  disabled
                  placeholder="State"
                />
                <TextInputField
                  label="Country:"
                  name="b_country"
                  value={formData.b_country}
                  disabled
                  placeholder="Country"
                />
                <TextInputField
                  label="Phone 1:"
                  name="b_phone1"
                  value={formData.b_phone1}
                  disabled
                  placeholder="Phone 1"
                />
                <TextInputField
                  label="Phone 2:"
                  name="b_phone2"
                  value={formData.b_phone2}
                  disabled
                  placeholder="Phone 2"
                />
              </div>
            </Col>
            <Col md={3} className="container-col">
              <div className="col-lg-12">
                <div className="form-group text-xl">
                  <b style={{ color: currentColor }}>SHIPPING ADDRESS</b>
                </div>
                <TextAreaField
                  label="Street:"
                  name="s_street"
                  value={formData.s_street}
                  disabled
                  placeholder="Street"
                />
                <TextInputField
                  label="City:"
                  name="s_city"
                  value={formData.s_city}
                  disabled
                  placeholder="City"
                />
                <TextInputField
                  label="Zip:"
                  name="s_zip"
                  value={formData.s_zip}
                  disabled
                  placeholder="Zip"
                />
                <TextInputField
                  label="State:"
                  name="s_state"
                  value={formData.s_state}
                  disabled
                  placeholder="State"
                />
                <TextInputField
                  label="Country:"
                  name="s_country"
                  value={formData.s_country}
                  disabled
                  placeholder="Country"
                />
                <TextInputField
                  label="Attention Name:"
                  name="s_name"
                  value={formData.s_name}
                  disabled
                  placeholder="Attention Name"
                />
                <TextInputField
                  label="Phone:"
                  name="s_phone"
                  value={formData.s_phone}
                  disabled
                  placeholder="Phone"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default ViewCustomer;
